import { useEffect } from 'react';
import { IframeOpener } from '../../vanillaComponent/iframe-opener';

function CheckAvailabilityWidget() {
  useEffect(() => {
    const openIframeContainer = document.getElementById('open-iframe');

    if (openIframeContainer && !openIframeContainer.querySelector('[id^="open-iframe-button"]')) {
      const widgetData = {
        token: 'THB3R1lNZmZodlpBNHg1TDVrellOMDZl',
        type: 'button',
        version: '1.0',
        module: 'check-availability',
      };

      new IframeOpener(widgetData).render(openIframeContainer);
    }
  }, []);

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <div id='open-iframe'></div>
      </div>
    </>
  );
}

export default CheckAvailabilityWidget;
